import script from "./NoticeCom.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticeCom.vue?vue&type=script&setup=true&lang=js"

import "./NoticeCom.vue?vue&type=style&index=0&id=cb6596bc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb6596bc"]])

export default __exports__